module.exports = __webpack_public_path__ + "static/media/IconFlussiggas.3762665e.svg";